import RechargeContainer from "./RechargeContainer"
import React from 'react'

const RechargeCreate = () => {
  return (
    <div className='page-body'>
      <RechargeContainer />
    </div>
  )
}

export default RechargeCreate